import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { WhatsAppIcon, WHATSAPP_URL } from "./WhatsAppIcon";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-char-900 text-paper">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center">
              <img
                src="https://customer-assets-4nw71qhi.emergentagent.net/job_site-creator-3339/artifacts/272i41rf_tanren-logo-dark-bg.png"
                alt="Tanren"
                className="h-9 w-auto"
              />
            </Link>
            <p className="mt-5 text-paper/75 text-base max-w-[42ch] leading-relaxed">
              End-to-end engineering for pyrolysis, torrefaction, gasification and CBG plants.
              From your biomass to a commissioned, revenue-producing facility, with one
              accountable partner.
            </p>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Regus%2C%20Platinum%20Techno%20Park%2C%20Sector%2030%2C%20Vashi%2C%20Navi%20Mumbai%2C%20Maharashtra%20400705"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="mt-5 block text-paper/75 hover:text-paper transition-colors text-base max-w-[42ch] leading-relaxed"
            >
              Level 13, Regus, Platinum Techno Park, Sector 30, Vashi, Navi Mumbai, Maharashtra
              400705, India
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="mono-label">Site</div>
            <ul className="mt-4 space-y-2.5">
              {[
                ["/about", "About"],
                ["/equipment", "Equipment"],
                ["/mrv", "MRV"],
                ["/services", "Services"],
                ["/learn", "Learn"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-paper hover:text-paper transition-colors text-base"
                    data-testid={`footer-link-${label.toLowerCase()}`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="mono-label">Contact</div>
            <a
              href="mailto:info@tanrentech.com"
              data-testid="footer-email"
              className="mt-4 inline-flex items-center gap-2 text-paper hover:text-ember transition-colors font-display text-xl tracking-tight"
            >
              info@tanrentech.com
              <ArrowUpRight size={18} />
            </a>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.linkedin.com/company/tanrentech"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-md border border-ember text-paper/85 hover:text-paper flex items-center justify-center transition-colors"
              >
                <Linkedin size={16} />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-md border border-ember text-paper/85 hover:text-paper flex items-center justify-center transition-colors"
              >
                <WhatsAppIcon size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-paper/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-paper/60">
          <div>© 2026 Tanren Pvt. Ltd. All Rights Reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
